export const FETCH_NEWS_PAGE = '@@news/FETCH_NEWS_PAGE';
export const FETCH_NEWS_PAGE_SUCCESS = '@@news/FETCH_NEWS_PAGE_SUCCESS';
export const FETCH_NEWS_PAGE_ERROR = '@@news/FETCH_NEWS_PAGE_ERROR';

export const FETCH_NEWS = '@@news/FETCH_NEWS';
export const FETCH_NEWS_SUCCESS = '@@news/FETCH_NEWS_SUCCESS';
export const FETCH_NEWS_ERROR = '@@news/FETCH_NEWS_ERROR';
